@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.loaderBox {
  justify-content: center;
}

.titleBox {
  text-align: center;
  justify-content: center;
  margin-top: 10px;
}

.title {
  font-size: 16px;
  line-height: 26px;
  color: v.$palette-gray-900;
}
